import _ from 'lodash'
import {renderSelf} from 'views/Shared'

export const codi_content_options = {
  name: {
    label: 'fullname',
    value: 'name',
  },
  short_name: {
    label: 'short name',
    value: 'short_name',
  },
  content: {
    label: 'content',
    value: 'content',
  },
  sub_content: {
    label: 'detail content',
    value: 'sub_content',
  },
  attach_link: {
    label: 'attach link',
    value: 'attach_link',
  },
}

export const createCodiContent = (option, translate = renderSelf) => {
  const notEmpty = (e) => String(e ?? '').length
  const next = (option, translate) => {
    const children = Array.from(option?.children ?? [])
    if (!children.length) {
      return ''
    }
    let body = children.map((item) => {
      const sub_content = next(item, translate)
      const { content, short_index_name } = item ?? {}
      const sub_children = Array.from(item?.children ?? [])
      if (_.isEmpty(content ?? '') && sub_children.length) {
        return sub_content
      }
      const text = short_index_name
        ? [short_index_name, content].filter(notEmpty).join(': ')
        : content
      const string = [text, sub_content].filter(notEmpty).join('')
      return string.length > 0 ? string : null
    })
    return body.filter(notEmpty).join('\n')
  }
  return next(option, translate) + '\n'
}
